// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__OcuDY","header":"PatientBlock_header__3KMKK","label":"PatientBlock_label__3jMCG","option":"PatientBlock_option__1vnjv"};